import { render, staticRenderFns } from "./ActionDispatcher.vue?vue&type=template&id=563089e1&scoped=true"
import script from "./ActionDispatcher.vue?vue&type=script&lang=js"
export * from "./ActionDispatcher.vue?vue&type=script&lang=js"
import style0 from "./ActionDispatcher.vue?vue&type=style&index=0&id=563089e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563089e1",
  null
  
)

export default component.exports